import Orientation from '../../../davinci/orientation'

export default function() {
  new Orientation($('#orientation'))
}